import './SupportPageHelpSection.scss';
import { Trans, useTranslation } from 'react-i18next';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { NavLink } from 'react-router-dom';

export default function SupportPageHelpSection() {
  const { t } = useTranslation();
  const myAccessEmail = t('settingsPage.helpSection.myAccessEmail');
  return (
    <div className="support-page-help-sec__container">
      <div className="support-page-help-sec__section">
        <div className="support-page-help-sec__section--title">
          {t('settingsPage.helpSection.haveAQuestionTitle')}
        </div>
        <div className="support-page-help-sec__section--description">
          <Trans i18nKey="settingsPage.helpSection.haveAQuestionDesc">
            <span style={{ fontWeight: 600 }}>{{ myAccessEmail }}</span>
          </Trans>
        </div>
        <a href="mailto: myaccess@aircanada.ca">
          <div className="support-page-help-sec__section--link">
            <EmailOutlinedIcon className="svgIcon" />
            {t('settingsPage.helpSection.haveAQuestionLink')}
          </div>
        </a>
      </div>
      {/* Need to enable the below section once the Faq Page is ready */}
      {document.location.pathname.replace(/\/$/, '') !== '/faqs' && (
        <div className="support-page-help-sec__section">
          <div className="support-page-help-sec__section--title">
            {t('settingsPage.helpSection.faqTitle')}
          </div>
          <div className="support-page-help-sec__section--description">
            {t('settingsPage.helpSection.faqDesc')}
          </div>
          <NavLink to="/faqs" className="support-page-help-sec__section--link">
            <ArticleOutlinedIcon className="svgIcon" />
            {t('settingsPage.helpSection.faqLink')}
          </NavLink>
        </div>
      )}
      {document.location.pathname.replace(/\/$/, '') !== '/acronyms' && (
        <div className="support-page-help-sec__section">
          <div className="support-page-help-sec__section--title">
            {t('settingsPage.helpSection.acronymTitle')}
          </div>
          <div className="support-page-help-sec__section--description">
            {t('settingsPage.helpSection.acronymDesc')}
          </div>
          <NavLink
            to="/acronyms"
            className="support-page-help-sec__section--link"
          >
            <ArticleOutlinedIcon className="svgIcon" />
            {t('settingsPage.helpSection.acronymLink')}
          </NavLink>
        </div>
      )}
    </div>
  );
}
